import { allTradeWays, type TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { AppState } from 'state/state.model';

function getCpOrderBcsProduct(state: AppState, tabId: string) {
  return state.secondaryMarket.cpOrder.referential.product[tabId]?.bcsProduct;
}

export function getCpOrderBcsProductName(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.name;
}

export function getCpOrderBcsProductCurrency(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.currency;
}

export function getCpOrderBcsProductCpTradeAuthorisation(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.cpTradeAuthorisation;
}

const askOnlyWays = ['ClientBuy'] satisfies TradeWay[];
const bidOnlyWays = ['ClientSell'] satisfies TradeWay[];
const emptyArray: readonly [] = [];

export function getAllowedTradeWays(state: AppState, tabId: string): readonly TradeWay[] {
  const cpTradeAuthorisation = getCpOrderBcsProductCpTradeAuthorisation(state, tabId);
  switch (cpTradeAuthorisation) {
    case 'Full':
      return allTradeWays;
    case 'Ask only':
      return askOnlyWays;
    case 'Bid only':
      return bidOnlyWays;
  }
  return emptyArray;
}

export function getDisabledTradeWays(state: AppState, tabId: string): readonly TradeWay[] {
  const allowedTradeWays = getAllowedTradeWays(state, tabId);
  return allTradeWays.filter(way => !allowedTradeWays.includes(way));
}

export function getCpOrderBcsProductIsin(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.isin;
}

export function getCpOrderBcsProductRic(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.ric;
}

export function getCpOrderBcsProductFileCode(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.fileCode;
}

export function getCpOrderBcsProductMaturityDate(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.maturityDate;
}

export function getCpOrderBcsProductDenomination(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.denomination;
}

export function getCpOrderBcsProductQuotationType(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.quotationType;
}

export function getCpOrderBcsProductPriceType(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.priceType;
}

export function getCpOrderBcsProductClients(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.clients;
}

export function getCpOrderBcsProductTraderGroup(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.traderGroup;
}
export function getCpOrderBcsProductPortfolio(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.portfolio;
}

export function getCpOrderBcsProductSalesMargin(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.salesMargin;
}

export function getCpOrderBcsProductExtraBid(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.extraBid;
}

export function getCpOrderBcsProductExtraAsk(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.extraAsk;
}

export function getCpOrderBcsProductBid(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.bid;
}

export function getCpOrderBcsProductAsk(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.ask;
}

export function getCpOrderBcsProductTraderLabel(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.traderLabel;
}

export function getCpOrderBcsProductTraderMessage(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.traderMessage;
}

export function getCpOrderBcsProductSalesMessage(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.salesMessage;
}

export function getCpOrderBcsProductFeedReutersD(state: AppState, tabId: string) {
  return getCpOrderBcsProduct(state, tabId)?.ric;
}
